import { useState, FC } from "react";
import { ChallengeCard } from "../challengeCard";
import { selectedCreatorTypeProps } from "../../types/props/OverviewProps";
import { ChallengeOverviewUi } from "./ChallengeOverview.ui";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Box, Grid } from "@radix-ui/themes";
import { Zones } from "@/models/database/zones/Zones.model";
import { useTenantChallenges } from "../../hooks/useTenantChallenges";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

interface ChallengesOverviewProps {
  zone?: Zones;
}

export const ChallengeOverview: FC<ChallengesOverviewProps> = ({
  zone,
}): JSX.Element => {
  const [challengeTitle, setChallengeTitle] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<
    "upcoming" | "ongoing" | "finished"
  >("ongoing");
  const [selectedGame, setSelectedGames] = useState<string | undefined>(
    undefined
  );
  const [selectedCreatorType, setSelectedCreatorType] =
    useState<selectedCreatorTypeProps>("discover-new");

  const { data, loading, error } = useTenantChallenges(
    brand.tenantId,
    selectedStatus
  );

  // Page Document Title
  if (selectedCreatorType === "mine") {
    useDocumentTitle("My challenges");
  }

  if (selectedCreatorType === "discover-new") {
    useDocumentTitle("Discover new challenges");
  }

  const filteredData = zone
    ? data?.filter((event) => event.zone === zone.slug)
    : data;

  return (
    <>
      <ChallengeOverviewUi
        selectedCreatorType={selectedCreatorType}
        setSelectedCreatorType={setSelectedCreatorType}
        loading={loading}
        selectedGame={selectedGame}
        setSelectedGames={setSelectedGames}
        challengeTitle={challengeTitle}
        setChallengeTitle={setChallengeTitle}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        zone={zone}
      />
      {selectedCreatorType === "mine" &&
        !loading &&
        filteredData?.length === 0 && (
          <div className="challenges__empty">
            <p>You haven't made any challenges yet. </p>
          </div>
        )}
      <Grid gap="5" columns={{ initial: "1", md: "2", lg: "4" }}>
        {filteredData &&
          filteredData.map((challenge, ind) => {
            const key = challenge.slug;

            return (
              <Box key={key}>
                {/* Render challenge card */}
                <ChallengeCard
                  created={challenge.created}
                  createdBy={challenge.author?.uid} // Possibility of author profile get deleted
                  creatorType={challenge.creatorType}
                  fieldToCompare={
                    challenge.challengeAdditionalData.fieldToCompare
                  }
                  game={challenge.game}
                  gameType={challenge.gameType}
                  goal={"win"} // Not getting from backend
                  logoUrl={challenge.logoUrl}
                  name={challenge.name}
                  slug={challenge.slug}
                  author={challenge.author}
                  startDate={{
                    _seconds: challenge.startDate.seconds,
                    _nanoseconds: challenge.startDate.nanoseconds,
                  }}
                  endDate={{
                    _seconds: challenge.endDate.seconds,
                    _nanoseconds: challenge.endDate.nanoseconds,
                  }}
                  status={challenge.status}
                  zone={zone}
                />
              </Box>
            );
          })}
      </Grid>
    </>
  );
};
